import React, { useEffect, useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "./ladder-logo-white.png";
import "./board.scss";

// The Ladder wordmark, small and quiet in the bottom-right corner of every
// board (Studio, legacy and alarm takeovers alike), for brand recognition.
// With `onLogout`, a small logout button sits to its right. Boards often run
// on touch kiosks, so it takes two taps: the first asks "Log out?" for a few
// seconds, the second signs out. The mark itself never takes clicks.
const CONFIRM_MS = 4000;

const LadderMark = ({ onLogout }) => {
  const [confirming, setConfirming] = useState(false);
  useEffect(() => {
    if (!confirming) return undefined;
    const t = setTimeout(() => setConfirming(false), CONFIRM_MS);
    return () => clearTimeout(t);
  }, [confirming]);

  return (
    <div className="sb-ladder-mark">
      <img src={logo} alt="" aria-hidden="true" draggable="false" />
      {onLogout && (
        <button
          type="button"
          className={`sb-ladder-logout${confirming ? " confirming" : ""}`}
          onClick={() => (confirming ? onLogout() : setConfirming(true))}
          title="Log out of this board"
          aria-label={confirming ? "Tap again to log out" : "Log out"}
        >
          {confirming && <span>Log out?</span>}
          <LogoutIcon />
        </button>
      )}
    </div>
  );
};

export default LadderMark;
